import urljoin from 'url-join';
import { api } from '@/shared/services/baseApiClient';
import { config } from '@/config/config';
import { SearchContactsRequest } from '@/features/contacts/models/searchContactsRequest';
import { PagedContactsViewModel } from '@/features/contacts/models/pagedContactsViewModel';

class ContactsApi {
  private version = 'v1';

  public getContacts(request: SearchContactsRequest, workspaceId: string): Promise<PagedContactsViewModel> {
    const url = urljoin(config().messagingHost, this.version, 'workspaces', workspaceId, 'appusers', 'search');
    return api.send('POST', url, request);
  }

  public getConversation(
    appUserId: string,
    workspaceId: string,
    continuationToken: string | '',
  ): Promise<GetMessagesResponse> {
    const url = urljoin(
      config().messagingHost,
      this.version,
      'workspaces',
      workspaceId,
      'appusers',
      appUserId,
      `messages?size=50&token=${encodeURIComponent(continuationToken)}`,
    );
    return api.send('GET', url);
  }
}

export const contactsApi = new ContactsApi();

export interface GetMessagesResponse {
  messages: MessageViewModel[];
  continuationToken: string;
}

export interface MessageViewModel {
  id: string;
  role: string;
  name: string;
  type: string;
  text: string;
  status: string;
  received: Date;
  app?: AppContentViewModel;
}

export interface AppContentViewModel {
  installedAppId: string;
  config: any;
  card: AppContentCardViewModel;
}

export interface AppContentCardViewModel {
  components: any[];
}
